module.exports = __webpack_public_path__ + "static/media/29.31b16167.png";